import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { MainStore, VolumeIndicators } from "../../store";
import IconButtonV2 from "../../../components/IconButtonV2";
import { VolumeSlider } from "../VolumeSlider";
import {
  SetMasterMuteAction,
  SetMasterVolumeAction,
  SET_MASTER_MUTE,
  SET_MASTER_VOLUME
} from "../../actions/actionTypes";
import { valToDb } from "../LaneVolumeSlider";
import { MasterVolumeContainer } from "./styles";

export function MasterVolumeControl({
  size = "md",
  style
}: {
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl";
  style?: React.CSSProperties;
}) {
  const isMuted = useSelector<MainStore, boolean>(
    state => state.uiState.masterMute
  );
  const volume = useSelector<MainStore, number>(
    state => state.uiState.masterVolume
  );
  let volumeIndicators = useSelector<MainStore, VolumeIndicators>(
    state =>
      state.uiState.masterVolumeIndicator || { currentPeak: 0, recentPeak: 0 }
  );
  const dispatch = useDispatch();
  const toggleMute = () => {
    dispatch<SetMasterMuteAction>({
      type: SET_MASTER_MUTE,
      isMuted: !isMuted
    });
  };

  const onChange = val => {
    dispatch<SetMasterVolumeAction>({
      type: SET_MASTER_VOLUME,
      volumeValue: valToDb(val / 100)
    });
  };

  return (
    <MasterVolumeContainer>
      <Popover
        placement="top"
        getPopupContainer={trigger => trigger}
        content={
          <VolumeSlider
            onChange={onChange}
            onAfterChange={onChange}
            currentVolume={volume}
            volumeIndicators={volumeIndicators}
            vertical
          />
        }
        {...(isMuted && { visible: false })}
      >
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          <IconButtonV2
            type={isMuted ? "volume_muted" : "volume"}
            size={size}
            onClick={toggleMute}
            selectedBackground={false}
            style={style}
          />
        </span>
      </Popover>
    </MasterVolumeContainer>
  );
}
